import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { IDmEmailConfigActionTypes } from "../../action-types/email/IDmEmailConfigActionTypes";
import { IDmEmailConfigReducer } from "../../page-state-model/email/IDmEmailConfigReducer";
const iniState: IDmEmailConfigReducer = {
    status: ePageBaseStatus.is_not_initialization,
    configs: []
}
export const dmEmailConfigReducer = (state: IDmEmailConfigReducer = iniState, action: IDmEmailConfigActionTypes): IDmEmailConfigReducer => {
    switch (action.type) {
        case "EMAIL_CONFIG_LOAD_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "EMAIL_CONFIG_LOAD_SUCCCES":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                configs: action.payload
            }
        case "EMAIL_CONFIG_LOAD_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                configs:[]
            }

        default:
            return state;
    }
}